var $e3e68b40fcb16018$exports = {};
$e3e68b40fcb16018$exports = {
  "help": "\u0414\u043E\u0432\u0456\u0434\u043A\u0430",
  "info": "\u0406\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0456\u044F"
};
export { $e3e68b40fcb16018$exports as default };